import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ApiError } from '../../../../core';
import { ITableSettings } from '../../../../domains/shared/components/table/interfaces/table-settings.interface';
import { ToastService } from '../../../../domains/shared/components/toast/services/toast.service';
import { UsuarioLogApi } from '../../apis/usuario-log.api';
import { IUsuarioLogAcesso, IUsuarioLogAcessoResponse } from '../../interfaces/usuario-log-acesso.interface';

// TODO: SUBISTITUIR ESTA INTERFACE POR INTERFACE DO PRÓPRIO COMPONENT DA TABLE
interface IHeader {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: 'asc' | 'desc';
}

@Component({
  selector: 'sgt-log-acesso-table',
  templateUrl: './log-acesso-table.component.html',
  styleUrls: ['./log-acesso-table.component.scss'],
})
export class LogAcessoTableComponent implements OnChanges {
  @Input() idUsuario: number;

  // Pagination
  page = 1;
  pageSize = 20;

  // Data
  logs: IUsuarioLogAcesso[] = [];
  totalItens = 0;

  // Table
  tableSettings: ITableSettings = {
    loading: false,
    isEmpty: false,
    showFooter: false,
    customTableClass: 'table table-striped table-hover',
    emptyMessage: 'Nenhum registro encontrado',
    totalItens: 0,
    itensPerPage: 20,
  };

  // Table Headers
  headers: IHeader[] = [
    {
      key: 'createdAt',
      label: 'Data',
      sortable: false,
      sortDirection: 'asc',
    },
    {
      key: 'nomeUsuarioCreated',
      label: 'Responsável',
      sortable: false,
      sortDirection: 'asc',
    },
    {
      key: 'evento',
      label: 'Evento',
      sortable: false,
      sortDirection: 'asc',
    },
    {
      key: 'observacao',
      label: 'Observação',
      sortable: false,
      sortDirection: 'asc',
    }
  ];

  constructor(private toastService: ToastService,
              private usuarioLogApi: UsuarioLogApi) { }


  ngOnChanges(changes: SimpleChanges) {
      for (const propName in changes) {
        // Ao mudar o usuário, recarrega os logs
        if (propName === 'idUsuario') {
            this.page = 1;
            this.fetchAcessos();
          }
      }
  }

  /** Ao realizar o scroll até o final da tabela, carrega mais registros */
  onScrollBottom() {
    // Verifica se já carregou todos os itens
    if (this.logs.length >= this.tableSettings.totalItens) {
      return;
    }

    this.page += 1;
    this.fetchAcessos(true);
  }

  /** Pesquisa os registros de logs de acessos do usuário */
  private fetchAcessos(isContentAppend: boolean = false) {
    this.usuarioLogApi.fetchAcessos(this.idUsuario, this.page, this.pageSize).subscribe({
      next: (response: IUsuarioLogAcessoResponse) => {
        const res = response;
        if (isContentAppend) {
          this.logs = [...this.logs, ...res.data];
        } else {
          this.logs = res.data;
        }

        this.tableSettings.totalItens = response.totalItens;
      },
      error: (error: ApiError) => {
        this.toastService.error(error.message || 'Erro ao pesquisar os registros de logs de acessos do usuário.', {
          title: error.cause || 'Aconteceu algo inesperado.',
          duration: 5000,
        });
        console.error('Erro ao pesquisar os registros de logs de acessos do usuário:', error);
      },
      complete: () => {
        this.setPaginationSettings();
      },
    });
  }

  /** Função de trackBy para otimização da renderização da tabela */
  trackById(_: number, item: IUsuarioLogAcesso): number {
    return item.id;
  }

  /** Define as configurações de paginação da tabela */
  private setPaginationSettings() {
    this.tableSettings.isEmpty = this.logs.length === 0;
    this.tableSettings.itensPerPage = this.logs.length;
  }
}
